<template>
  <el-form
    :model="form"
    :rules="dataRule"
    ref="form"
    label-width="100px"
    size="mini"
  >
    <el-form-item
      label="标题"
      prop="title"
    >
      <el-input
        v-model="form.title"
        placeholder="标题"
      ></el-input>
    </el-form-item>
    <el-form-item label="链接" prop="url">
      <el-input v-model="form.url" placeholder="跳转链接"></el-input>
    </el-form-item>
    <div>
      <el-form-item label="小程序appid" prop="miniprogram.appid">
        <el-input v-model="form.miniprogram.appid" placeholder="小程序appid"></el-input>
      </el-form-item>
      <el-form-item label="小程序路径" prop="miniprogram.pagePath">
        <el-input v-model="form.miniprogram.pagePath" placeholder="小程序pagePath"></el-input>
      </el-form-item>
    </div>
    <el-row>
      <el-col :span="16">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="form.name" placeholder="模版名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="有效" prop="status">
          <el-switch v-model="form.status" placeholder="是否有效" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="form-group-area">
      <el-form-item class="form-group-title">消息填充数据，请对照模板内容填写</el-form-item>
      <el-form-item>
        <el-input
          type="textarea"
          disabled
          autosize
          v-model="form.content" placeholder="模版"></el-input>
      </el-form-item>
      <el-row v-for="(item,index) in form.data" :key="item.name">
        <el-col :span="16">
          <el-form-item :label="item.name" :prop="'data.'+index+'.value'"
                        :rules="[{required: true,message: '填充内容不得为空', trigger: 'blur' }]">
            <el-input
              type="textarea"
              autosize
              rows="1"
              v-model="item.value" placeholder="填充内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="颜色">
            <el-input type="color" v-model="item.color" placeholder="颜色"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </el-form>
</template>

<script>
let origin = {
  id: 0,
  templateId: '',
  title: '',
  data: [],
  url: '',
  miniprogram: {appid: '', pagePath: ''},
  content: '',
  status: true,
  name: ''
}
export default {
  name: "msgTplForm",
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      dataRule: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'}
        ],
        data: [
          {required: true, message: '内容不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '模版名称不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.form.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        if (this.form.id) {
          this.$http({
            url: `/wx/manage/msgTemplate/info/${this.form.id}`,
            method: 'get',
          }).then((data) => {
            if (data.code === 200) {
              this.transformTemplate(data.msgTemplate)
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    /**
     * 根据content信息展开data配置项(content为微信公众平台后台配置的模板)
     * 如content='{{first.DATA}} ↵商品名称：{{keyword1.DATA}} ↵购买时间：{{keyword2.DATA}} ↵{{remark.DATA}}'
     * 则生成data=[{name:'first',value:'',color:''},{name:'first',value:'',color:''},{name:'first',value:'',color:''}]
     * 展示表单让管理员给对应的字段填充内容
     */
    transformTemplate(template) {
      if (!template.miniprogram) template.miniprogram = {appid: '', pagePath: ''};

      if (template.data instanceof Array) {//已经配置过了，直接读取
        this.form = template
        return
      }

      template.data = [];
      let keysArray = template.content.match(/\{\{(\w*)\.DATA\}\}/g) || [] //示例： ["{{first.DATA}}", "{{keyword1.DATA}}", "{{keyword2.DATA}}", "{{remark.DATA}}"]
      keysArray.map(item => {
        name = item.replace('{{', '').replace('.DATA}}', '')
        template.data.push({"name": name, "value": "", color: "#000000"})
      })
      this.form = template;
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      })
    },
    selfClear() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    }
  },
}
</script>

<style scoped>

</style>
